<div class="fx-layout-col fx-justify-center fx-align-center fx-gap-20">
  <img [lazyLoad]="srcImg" width="450px" height="300px" alt="image" [defaultImage]="appConfig.PLACEHOLDER_PICTURE"/>
  <button type="button" mat-stroked-button (click)="imageInput.click()">
    {{ 'BUTTON.CHOOSE_PICTURE' | translate }}
  </button>
  <input hidden (change)="previewImage($event)" accept="image/png, image/jpeg, image/gif, image/webp" #imageInput
         type="file">
  @if (fileSizeError) {
    <span class="mat-mdc-form-field-error">
      {{ 'ERROR.UPLOAD_FILE_SIZE' | translate: {'max': appConfig.MAX_FILE_SIZE / 1024} }}
    </span>
  }
  @if (fileTypeError) {
    <span class="mat-mdc-form-field-error">
      {{ 'ERROR.WRONG_IMAGE_TYPE' | translate }}
    </span>
  }
</div>
